export default "__VITE_ASSET__7SG0hP_V__"